/**
 * Created by Bazu-05 on 27.05.2020.
 */
import {login, logout, removeClient, approveUnverified, declineUnverified} from '@/api/studioServices'
export const studio = {
    state: {
        studio: localStorage.getItem('studio') ? JSON.parse(localStorage.getItem('studio')) : {}
    },
    getters: {
        getStudio: state => state.studio
    },
    mutations: {
        SAVE_STUDIO(state, payload) {
            let {jwt, studio} = payload
            state.studio = studio;
            localStorage.setItem('studio_jwt', jwt)
            localStorage.setItem('studio', JSON.stringify(studio))
        },
    },
    actions: {
        async STUDIO_MAKE_AUTH({commit, dispatch}, data){
            try {
                let response = await login(data)
                const {jwt, studio} = response.data.data;
                commit('SAVE_STUDIO', {jwt, studio})
                return response;
            } catch(e) {
                dispatch('errorsHander', e.response)
            }
        },
        async STUDIO_REMOVE_CLIENT({dispatch}, clientId) {
            try {
                let data = await removeClient(clientId);
                if(data && data.status === 200) {
                    dispatch('ADD_ALERT', {type: 'success', text: "User successfully deleted"})
                    dispatch('STUDIO_REFRESH_CLIENTS_TABLE');
                } else {
                    dispatch('ADD_ALERT', {type: 'error', text: "Something went wrong"})
                }
                return data;
            }catch(e) {
                console.log(e.response, 'e.response')
            }
        },
        async STUDIO_APPROVE_UNVERIFIED({dispatch}, clientId) {
            try {
                let data = await approveUnverified(clientId);
                if(data && data.status === 200) {
                    dispatch('ADD_ALERT', {type: 'success', text: "User successfully approved"})
                    dispatch('STUDIO_REFRESH_CLIENTS_TABLE');
                } else {
                    dispatch('ADD_ALERT', {type: 'error', text: "Something went wrong"})
                }
                return data;
            }catch(e) {
                console.log(e.response, 'e.response')
            }
        },
        async STUDIO_DECLINE_UNVERIFIED({dispatch}, clientId) {
            try {
                let data = await declineUnverified(clientId);
                if(data && data.status === 200) {
                    dispatch('ADD_ALERT', {type: 'success', text: "User successfully declined"})
                    dispatch('STUDIO_REFRESH_CLIENTS_TABLE');
                } else {
                    dispatch('ADD_ALERT', {type: 'error', text: "Something went wrong"})
                }
                return data;
            }catch(e) {
                console.log(e.response, 'e.response')
            }
        },

        async STUDIO_MAKE_LOGOUT() {
            return await logout();
        },
    }
}